var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{ref:"customField",staticClass:"custom-text-field",attrs:{"value":_vm.value,"label":_vm.label,"rules":[_vm.customRules],"color":"accent","outlined":"","maxlength":_vm.maxLength},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }